import BaseController from "../sharedControllers/BaseController";
import { Routes } from "akademika/akamont/constants/Routes";
import { CreateWorkOrderDto } from "akademika/akamont/models/CreateWorkOrderDto";
import JSONModel from "sap/ui/model/json/JSONModel";
import DependentBusinessUnitPartnerDataUtil from "../../utils/DependentBusinessUnitPartnerDataUtil";
import ComboBox, {
  ComboBox$ChangeEvent,
  ComboBox$SelectionChangeEvent,
} from "sap/m/ComboBox";
import {
  SetOnlyMyContractsSelected,
  ToggleOnlyMyContracts,
  UpdateContractInfoOnChange,
  UpdateContractInfoOnLoad,
} from "akademika/akamont/utils/WorkOrderMainContractUtil";
import { WorkOrderDetailsInternalDto } from "akademika/akamont/models/WorkOrderDetailsInternalDto";
import { WorkOrderSelectData } from "akademika/akamont/models/WorkOrderSelectData";
import { IsUserAdmin, IsUserInternal } from "../../services/AuthService";
import { CheckMainContract } from "akademika/akamont/utils/WorkOrderContractCheckUtil";
import { WorkOrderMainContractLogicController } from "../sharedControllers/WorkOrderMainContractLogicController";
import Event from "sap/ui/base/Event";
import { MainContractOptionDto } from "../../models/MainContractOptionDto";

/**
 * @namespace akademika.akamont.pages.workOrderAdd
 */
export default class WorkOrderAdd
  extends BaseController
  implements WorkOrderMainContractLogicController {
  route = Routes.WORK_ORDER_ADD;
  parentRoute = Routes.WORK_ORDER_LIST;

  _workOrderSelectDataPromise: Promise<WorkOrderSelectData>;

  public async onRouteMatched() {
    this._workOrderSelectDataPromise = this.fetchModel<WorkOrderSelectData>(
      "api/WorkOrder/GetWorkOrderSelectData",
      "workOrderSelectData"
    );

    this.setModel(
      new JSONModel({
        mainContract: {},
        contractPrice: 0,
        contractDistance: 0,
      })
    );

    this.setModel(new JSONModel({ value: IsUserAdmin() }), "isUserAdmin");
    this.setModel(new JSONModel({ value: true }), "noMainContract");
    SetOnlyMyContractsSelected(this, true);

    if (this.routeParams.workOrderId) {
      const workOrderDetails =
        await this.fetchModel<WorkOrderDetailsInternalDto>(
          "api/WorkOrder/GetWorkOrderDetailsForInternal/" +
          this.routeParams.workOrderId
        );

      UpdateContractInfoOnLoad(this, workOrderDetails.mainContract);
    }

    await this.updateBusinessUnitPartnerInputs();
  }

  public async addWorkOrder() {
    const requestData = this.getModel().getData() as CreateWorkOrderDto;

    const workOrderId = await this.post("api/WorkOrder/CreateWorkOrder", {
      body: requestData,
    });

    const targetRoute = IsUserInternal()
      ? Routes.WORK_ORDER_DETAILS_INTERNAL
      : Routes.WORK_ORDER_DETAILS_PARTNER;

    this.navTo(targetRoute, { workOrderId });
  }

  public async updateBusinessUnitPartnerInputs() {
    const dependentBusinessUnitPartnerDataUtil =
      new DependentBusinessUnitPartnerDataUtil(this);

    const oModel = this.getModel();

    const businessUnitId = oModel.getProperty("/businessUnitId");
    const partnerId = oModel.getProperty("/partnerId");

    const selectData =
      await dependentBusinessUnitPartnerDataUtil.UpdateSelectData(
        businessUnitId,
        partnerId,
        "businessUnitsPartnersSelect"
      );

    if (selectData.businessUnits.length === 1)
      oModel.setProperty(
        "/businessUnitId",
        selectData.businessUnits[0].businessUnitId
      );
  }

  public async onMainContractSelected(_event: ComboBox$SelectionChangeEvent) {
    UpdateContractInfoOnChange(this);

    const selectedItemId = (this.byId('mainContractId') as ComboBox).getSelectedKey();
    const model = this.getModelData('mainContractOptions') as MainContractOptionDto[];
    const contract = model.find(mc => selectedItemId === String(mc.contractId));

    const workOrderId = this.routeParams.workOrderId;

    CheckMainContract(this, contract, workOrderId);
  }

  public updateContractInfoText(event: ComboBox$ChangeEvent) {
    const model = this.getModel();
    model.setProperty("/mainContract/sapId", event.getParameter("value"));
  }

  public toggleOnlyMyContracts = ToggleOnlyMyContracts;

  public postMainContractControlFilter(oEvent: Event) {
    const body = {
      dispayMainContract:
        this.getModel("noMainContract")?.getProperty("/value") ?? false,
    };
    super.postControlFilter(oEvent, body);
  }
}
